/**
 * @description Get the query parameters for the Google Maps/Apple Maps APIs
 * @param name - The name of the restaurant
 * @param address - The address of the restaurant
 * @param latitude - The latitude of the restaurant
 * @param longitude - The longitude of the restaurant
 * @returns {string} - The query parameters for the Google Maps/Apple Maps APIs
 */
export function getMapURLQueryParams({
  name,
  address,
  latitude,
  longitude
}: {
  name?: string
  address: string
  latitude: number
  longitude: number
}): string {
  return `?q=${address}${name ? '+' + name : ''}&ll${latitude},${longitude}`.replaceAll(' ', '+')
}
